package org.vreo.devicehub.features.vrmOutput.presentation.components

import org.vreo.devicehub.features.core.presentation.UiText
import org.vreo.devicehub.features.core.domain.device.vrmConfig.VrmOutputType
import devicehub.composeapp.generated.resources.Res
import devicehub.composeapp.generated.resources.vrm_output_type_apt
import devicehub.composeapp.generated.resources.vrm_output_type_other
import devicehub.composeapp.generated.resources.vrm_output_type_surepark
import devicehub.composeapp.generated.resources.vrm_output_type_zatpark


/**
 * Convert [VrmOutputType] to [UiText].
 *
 * @return [UiText] on success, error otherwise
 */
fun VrmOutputType.toUiText(): UiText {
    val stringRes = when (this) {
        VrmOutputType.ZATPARK -> Res.string.vrm_output_type_zatpark
        VrmOutputType.APT -> Res.string.vrm_output_type_apt
        VrmOutputType.SUREPARK -> Res.string.vrm_output_type_surepark
        VrmOutputType.OTHER -> Res.string.vrm_output_type_other
    }

    return UiText.StringResourceId(stringRes)
}